import {types, applySnapshot} from 'mobx-state-tree';

const GroupModel = types.model('Group', {
    id: types.identifierNumber,
    name: types.string,
    groupId: types.integer,
    attributes: types.frozen({}),
    createdByUserId: types.maybeNull(types.number),
    createdAt: types.maybeNull(types.string),
    updatedAt: types.maybeNull(types.string),
})
    .actions((self) => ({
        update: (data) => {
            applySnapshot(self, {id: self.id, ...data});
        },
    }));

export default GroupModel;
